import _Set from "@babel/runtime-corejs3/core-js-stable/set";
import { warning } from '@jutro/logger';
const loggedMessages = new _Set();
export const logDeprecationMessage = (deprecated, alternative, extraMessage = '', dropTargetVersion) => {
  let message = "".concat(deprecated, " has been deprecated.");
  if (alternative) {
    message += " Please use ".concat(alternative, " instead.");
  }
  if (extraMessage) {
    message += " ".concat(extraMessage);
  }
  if (dropTargetVersion) {
    message += " It will be removed in the \"".concat(dropTargetVersion, "\" Jutro release.");
  }
  if (loggedMessages.has(message)) {
    return;
  }
  loggedMessages.add(message);
  warning(message, {
    bold: true
  });
};